import { DICT_PAGES, RULES_PAGES } from "./i18n_pages";

export const DICT = {
  ...DICT_PAGES,
  // Nav / shell
  "Inicio": "Home", "Calendario": "Calendar", "Mis WishList": "My WishLists", "Buscar": "Search",
  "Bandeja de entrada": "Inbox", "Espacios": "Spaces", "Mis Espacios": "My Spaces", "Perfil": "Profile",
  "Mi perfil": "My profile", "Cerrar sesión": "Log out", "Tema claro": "Light theme", "Tema oscuro": "Dark theme",
  "Nuevo Espacio": "New Space", "Crear Espacio": "Create Space", "Agenda": "Agenda", "Ajustes": "Settings",
  // Auth
  "Inicia sesión": "Log in", "Entrar": "Sign in", "Regístrate": "Sign up", "Crea tu cuenta": "Create your account",
  "Crear cuenta": "Create account", "¿No tienes cuenta?": "Don't have an account?",
  "¿Ya tienes cuenta?": "Already have an account?", "Accede a tus Espacios": "Access your Spaces",
  "Empieza a organizar tu mundo": "Start organizing your world", "Contraseña": "Password",
  "Tareas asignadas a mí": "Tasks assigned to me", "Agrupar por": "Group by",
  "Tarea padre": "Parent task", "Fecha límite": "Due date", "Sin fecha": "No date",
  "Próximos 7 días": "Next 7 days", "Más adelante": "Later", "Solo vencidas": "Overdue only",
  "Abiertas": "Open", "Completadas": "Completed", "Toda prioridad": "Any priority",
  "Ocultar finalizados": "Hide completed", "Duplicar proyecto": "Duplicate project",
  "Eliminar proyecto": "Delete project", "Duplicar": "Duplicate", "Tarea duplicada": "Task duplicated",
  "Carga del equipo": "Team workload", "Tareas abiertas por responsable": "Open tasks by assignee",
  "Fuera de plazo": "Overdue", "Sin responsable": "Unassigned",
  "¿Eliminar este proyecto?": "Delete this project?", "Proyecto eliminado": "Project deleted",
  "Avisarme el día antes": "Remind me the day before", "Mañana:": "Tomorrow:",
  "Correo electrónico": "Email",
  "Un único Espacio para todo lo que importa.": "A single Space for everything that matters.",
  "Organiza, conecta y disfruta.": "Organize, connect and enjoy.",
  "Recordarme": "Remember me", "o continúa con": "or continue with",
  "Continuar con Google": "Continue with Google",
  "Todo tu mundo": "Your whole world", "Organiza sin esfuerzo": "Organize effortlessly",
  "Conecta personas": "Connect people", "Privado y seguro": "Private and secure",
  "Con IA que te ayuda": "With AI that helps you",
  "Un Espacio, infinitas posibilidades": "One Space, endless possibilities",
  "Familia, trabajo, viajes, clubes… Todo en un mismo lugar.": "Family, work, travel, clubs… All in one place.",
  "Tareas, proyectos, eventos, gastos y más. Simple y visual.": "Tasks, projects, events, expenses and more. Simple and visual.",
  "Conversaciones, archivos y decisiones siempre al alcance.": "Conversations, files and decisions always within reach.",
  "Tus datos y los de los tuyos, protegidos siempre.": "Your data and your loved ones', always protected.",
  "Encuentra, resume y planifica con tu asistente inteligente.": "Find, summarize and plan with your smart assistant.",
  "Adapta Nuxxum a tu forma de vivir y trabajar.": "Adapt Nuxxum to the way you live and work.",
  "Todo en su sitio. Todos conectados.": "Everything in its place. Everyone connected.",
  "Todo en su sitio.": "Everything in its place.", "Todos conectados.": "Everyone connected.",
  "tu@correo.com": "you@email.com",
  "El núcleo donde todo conecta y encuentra su sitio.": "The core where everything connects and finds its place.",
  "Plataforma centralizada": "Centralized platform",
  "Todo lo que necesitas en un único espacio inteligente.": "Everything you need in a single smart space.",
  "Conecta personas y cosas": "Connect people and things",
  "Calendarios, tareas, proyectos, conversaciones y más.": "Calendars, tasks, projects, conversations and more.",
  "Menos ruido, más claridad": "Less noise, more clarity",
  "Interfaz calmada para que te enfoques en lo importante.": "A calm interface so you can focus on what matters.",
  "Inteligencia que te anticipa": "Intelligence that anticipates you",
  "Sugerencias, automatizaciones y contexto en el momento justo.": "Suggestions, automations and context at just the right moment.",
  "Familia": "Family", "Viajes": "Travel", "Clubes": "Clubs",
  "Mínimo 6 caracteres": "At least 6 characters", "Nombre completo": "Full name", "Un momento...": "One moment...",
  "¿Olvidaste tu contraseña?": "Forgot your password?",
  "Notificaciones en el móvil": "Mobile notifications",
  "Recibe fuera de la app lo que hoy te llega por la campana": "Get outside the app what the bell delivers today",
  "Vincular Telegram": "Link Telegram", "Desvincular": "Unlink", "Probar": "Test", "Sin vincular": "Not linked",
  "Notificaciones del navegador": "Browser notifications",
  "Activar en este dispositivo": "Enable on this device", "Desactivar": "Disable",
  "Activas en este dispositivo": "Active on this device", "Desactivadas en este dispositivo": "Disabled on this device",
  "Qué quieres recibir": "What you want to receive",
  "Chat y menciones": "Chat and mentions", "Gastos y presupuestos": "Expenses and budgets", "Otras": "Other",
  "Resumen diario por Telegram": "Daily Telegram digest",
  "Cada mañana a las 8:00: tus tareas del día y tu agenda": "Every morning at 8:00: your tasks for the day and your agenda",
  "Nombre": "Name", "Email": "Email", "Cuenta creada. ¡Bienvenido a Nuxxum!": "Account created. Welcome to Nuxxum!",
  // Home
  "Mis tareas de hoy": "My tasks for today", "Hoy": "Today", "Vencida": "Overdue",
  "Actividad reciente": "Recent activity", "Invitaciones pendientes": "Pending invitations",
  "Presupuestos en alerta": "Budgets on alert", "Ver todo": "View all", "Aceptar": "Accept", "Rechazar": "Decline",
  "Crea tu primer Espacio para empezar a organizar tu mundo.": "Create your first Space to start organizing your world.",
  // Space
  "Resumen": "Overview", "Proyectos": "Projects", "Chat": "Chat", "Archivos": "Files", "Fotos": "Photos",
  "Encuestas": "Polls", "Actividad": "Activity", "Cuentas (€)": "Accounts (€)", "Lista Compra": "Shopping List",
  "Miembros": "Members", "Administrar": "Manage", "Salir del Espacio": "Leave Space", "Huchas": "Piggy banks",
  "Recompensas ganadas completando tareas": "Rewards earned by completing tasks",
  "Nuevo proyecto": "New project", "Sin proyectos todavía": "No projects yet",
  // Projects / tasks
  "Tareas": "Tasks", "Lista": "List", "Tablero": "Board", "Gantt": "Gantt", "Nueva tarea": "New task",
  "Título": "Title", "Estado": "Status", "Prioridad": "Priority", "Responsable": "Assignee",
  "Fecha límite": "Due date", "Fecha inicio": "Start date", "Fechas": "Dates", "Descripción": "Description",
  "Subtareas": "Subtasks", "Añadir subtarea": "Add subtask", "Comentarios": "Comments", "Adjuntos": "Attachments",
  "Pendiente": "To do", "En progreso": "In progress", "En revisión": "In review", "Completada": "Done",
  "Baja": "Low", "Media": "Medium", "Alta": "High", "Crítica": "Critical",
  "Sin asignar": "Unassigned", "Sin fecha": "No date", "Guardar": "Save", "Cancelar": "Cancel",
  "Eliminar": "Delete", "Editar": "Edit", "Crear": "Create", "Cerrar": "Close", "Guardando…": "Saving…",
  "Guardando...": "Saving...", "Creando...": "Creating...", "Crear tarea": "Create task",
  "Tarea creada": "Task created", "Recompensa (€)": "Reward (€)", "opcional": "optional",
  "Repetición": "Recurrence", "No se repite": "Does not repeat", "Diaria": "Daily", "Semanal": "Weekly",
  "Cada 2 semanas": "Every 2 weeks", "Mensual": "Monthly", "Anual": "Yearly",
  "Al completarla se creará la siguiente automáticamente.": "When completed, the next one will be created automatically.",
  "Se abonará a la hucha del responsable al completarla.": "It will be paid into the assignee's piggy bank upon completion.",
  "Depende de": "Depends on", "+ Añadir dependencia": "+ Add dependency",
  "No se podrá completar hasta que sus dependencias estén completadas.": "It cannot be completed until its dependencies are done.",
  "Tarjetas": "Cards", "Mostrar en las tarjetas": "Show on cards", "Lista de subtareas": "Subtask list",
  "Imagen adjunta": "Attached image", "El título es obligatorio": "Title is required",
  "Tarea": "Task", "Subtarea": "Subtask", "Vencidas": "Overdue", "Filtros": "Filters",
  "tarea sin planificar (requieren fecha de inicio y fin)": "unplanned task (start and end dates required)",
  "tareas sin planificar (requieren fecha de inicio y fin)": "unplanned tasks (start and end dates required)",
  "Exportar CSV": "Export CSV",
  // Calendar
  "Mis calendarios": "My calendars", "Mostrar tareas": "Show tasks", "Mes": "Month", "Semana": "Week",
  "Crear en el calendario": "Create on calendar", "Evento": "Event", "Editar evento": "Edit event",
  "Crear evento": "Create event", "Evento creado": "Event created", "Evento actualizado": "Event updated",
  "Evento eliminado": "Event deleted", "Reunión": "Meeting", "Cita": "Appointment", "Cumpleaños": "Birthday",
  "Recordatorio": "Reminder", "Otro": "Other", "Tipo": "Type", "Todo el día": "All day",
  "Hora inicio": "Start time", "Hora fin": "End time", "Ubicación (opcional)": "Location (optional)",
  "Asistentes": "Attendees", "Descripción (opcional)": "Description (optional)", "Personal": "Personal",
  "Guardar cambios": "Save changes", "Fin": "End", "Elige una fecha": "Pick a date",
  "Enero": "January", "Febrero": "February", "Marzo": "March", "Abril": "April", "Mayo": "May", "Junio": "June",
  "Julio": "July", "Agosto": "August", "Septiembre": "September", "Octubre": "October",
  "Noviembre": "November", "Diciembre": "December",
  "Lun": "Mon", "Mar": "Tue", "Mié": "Wed", "Jue": "Thu", "Vie": "Fri", "Sáb": "Sat", "Dom": "Sun",
  "Lunes": "Monday", "Martes": "Tuesday", "Miércoles": "Wednesday", "Jueves": "Thursday",
  "Viernes": "Friday", "Sábado": "Saturday", "Domingo": "Sunday",
  // Expenses
  "Movimientos": "Transactions", "Balances": "Balances", "Presupuestos": "Budgets", "Informe": "Report",
  "Registrar": "Add entry", "Registrar movimiento": "Add transaction", "Gasto": "Expense", "Ingreso": "Income",
  "Registrar gasto": "Add expense", "Registrar ingreso": "Add income", "Gasto registrado": "Expense added",
  "Ingreso registrado": "Income added", "Concepto": "Concept", "Importe": "Amount", "Categoría": "Category",
  "¿Quién pagó?": "Who paid?", "¿Quién lo recibe?": "Who receives it?", "Método de reparto": "Split method",
  "A partes iguales": "Split equally", "Sin reparto": "No split", "Todo tipo": "All types", "Gastos": "Expenses",
  "Ingresos": "Income", "Neto": "Net", "Gastos por categoría": "Expenses by category",
  "Ranking del mes por persona": "Monthly ranking by person", "Sin movimientos este mes.": "No transactions this month.",
  "Sin gastos este mes.": "No expenses this month.", "Alimentación": "Food", "Transporte": "Transport",
  "Alojamiento": "Lodging", "Compras": "Shopping", "Ocio": "Leisure", "Hogar": "Home", "Trabajo": "Work",
  "Otros": "Other", "Liquidado": "Settled", "Cancelado": "Cancelled", "Fecha": "Date",
  "Diez segundos y listo. El resto es opcional.": "Ten seconds and done. The rest is optional.",
  "Todos": "All", "Nuevo presupuesto": "New budget",
  // Shopping
  "Lista de la compra": "Shopping list", "Añadir artículo… (ej: Leche)": "Add item… (e.g. Milk)", "Cant.": "Qty",
  "Vaciar comprados": "Clear purchased", "La lista está vacía. Añade lo que haga falta comprar.": "The list is empty. Add whatever needs buying.",
  // Wishlist
  "Nueva lista": "New list", "Nuevo deseo": "New wish", "Editar deseo": "Edit wish", "Deseo": "Wish",
  "Deseo añadido": "Wish added", "Deseo actualizado": "Wish updated", "Deseo eliminado": "Wish deleted",
  "¿Qué deseas?": "What do you wish for?", "Precio (€)": "Price (€)", "Ver en tienda": "View in store",
  "Compartir": "Share", "Compartidas conmigo": "Shared with me", "Con mis Espacios": "With my Spaces",
  "Lista creada": "List created", "Lista eliminada": "List deleted", "Lista renombrada": "List renamed",
  "Nueva lista de deseos": "New wish list", "Crear lista": "Create list",
  "Enlace de compra (opcional)": "Purchase link (optional)", "Añadir a la lista": "Add to list",
  "Aún no tienes ninguna lista de deseos": "You don't have any wish list yet",
  "Lista vacía. Añade tu primer deseo.": "Empty list. Add your first wish.",
  "Con personas concretas (emails separados por coma)": "With specific people (comma-separated emails)",
  "Ideas de regalo para quien quiera acertar contigo.": "Gift ideas for anyone who wants to get it right.",
  "Quienes la vean tendrán ideas de regalo para ti.": "Whoever sees it will have gift ideas for you.",
  "Crea listas distintas: Lista Regalos, Lista Reforma Habitación…": "Create different lists: Gift List, Room Makeover List…",
  "Foto añadida": "Photo added", "Añadir foto": "Add photo",
  // Members / settings
  "General": "General", "Equipos": "Teams", "Roles": "Roles", "Auditoría": "Audit", "Invitaciones": "Invitations",
  "Automatizaciones": "Automations", "Invitar": "Invite", "Añadir miembro sin email": "Add member without email",
  "Miembro sin cuenta": "Member without account", "Sin email": "No email",
  "Sin cuenta · no puede iniciar sesión": "No account · cannot log in", "Color del avatar": "Avatar color",
  "Añadir al Espacio": "Add to Space", "Propietario": "Owner", "Administrador": "Admin", "Miembro": "Member",
  "Invitado": "Guest", "Nueva regla": "New rule", "Nueva automatización": "New automation",
  "Cuando… (disparador)": "When… (trigger)", "Entonces… (acción)": "Then… (action)",
  "Se crea una tarea": "A task is created", "Se completa una tarea": "A task is completed",
  "Se asigna una tarea": "A task is assigned", "Se registra un gasto": "An expense is added",
  "Se sube un archivo": "A file is uploaded", "Se cierra una encuesta": "A poll is closed",
  "Enviar notificación": "Send notification", "Publicar mensaje en el Canal General": "Post message to General Channel",
  "Crear regla": "Create rule", "Regla creada": "Rule created", "Regla eliminada": "Rule deleted",
  "Ver historial de ejecuciones": "View run history", "Ocultar historial": "Hide history",
  "Sin automatizaciones todavía": "No automations yet", "Notificar a": "Notify",
  "Todos los miembros": "All members", "El responsable de la tarea": "The task assignee",
  // AI
  "Asistente IA": "AI Assistant", "Nunca modifica nada sin tu confirmación": "Never changes anything without your confirmation",
  "Escribe tu pregunta…": "Type your question…", "Pensando…": "Thinking…", "Confirmar": "Confirm", "Hecho": "Done",
  "Resume el estado del Espacio": "Summarize the Space status",
  "¿Qué tareas están pendientes y quién las lleva?": "Which tasks are pending and who owns them?",
  "Resume la conversación reciente del chat": "Summarize the recent chat conversation",
  "¿Cómo van los gastos y presupuestos?": "How are expenses and budgets going?",
  // Profile
  "Idioma": "Language", "Foto de perfil actualizada": "Profile photo updated", "Quitar foto": "Remove photo",
  "Cambiar contraseña": "Change password", "Contraseña actual": "Current password",
  "Nueva contraseña": "New password", "Perfil actualizado": "Profile updated", "Apariencia": "Appearance",
  // Inbox / chat / misc
  "Pendientes": "Pending", "Leídas": "Read", "Marcar todo como leído": "Mark all as read",
  "Escribe un mensaje...": "Type a message...", "Canal": "Channel", "Directos": "Direct",
  "Subir": "Upload", "Subiendo...": "Uploading...", "Subir fotos": "Upload photos", "Biblioteca": "Library",
  "Papelera": "Trash", "Buscar archivos...": "Search files...", "Crear encuesta": "Create poll",
  "Votar": "Vote", "Cambiar voto": "Change vote", "Cerrada": "Closed", "Activa": "Active",
  "Buscar o ejecutar una acción...": "Search or run an action...",
};

const plural = (n, s, p) => `${n} ${Number(n) === 1 ? s : p}`;

export const RULES = [
  ...RULES_PAGES,
  [/^Buenos días, (.+)$/, (m) => `Good morning, ${m[1]}`],
  [/^Buenas tardes, (.+)$/, (m) => `Good afternoon, ${m[1]}`],
  [/^Buenas noches, (.+)$/, (m) => `Good evening, ${m[1]}`],
  [/^Hoy tienes (\d+) tareas?( y (\d+) vencidas?)?\.$/, (m) =>
    `Today you have ${plural(m[1], "task", "tasks")}${m[3] ? ` and ${m[3]} overdue` : ""}.`],
  [/^Hoy tienes (\d+) vencidas?\.$/, (m) => `Today you have ${m[1]} overdue.`],
  [/^Hucha de (.+)$/, (m) => `${m[1]}'s piggy bank`],
  [/^WishList de (.+)$/, (m) => `${m[1]}'s WishList`],
  [/^añadido por (.+)$/, (m) => `added by ${m[1]}`],
  [/^pagó (.+)$/, (m) => `paid by ${m[1]}`],
  [/^recibió (.+)$/, (m) => `received by ${m[1]}`],
  [/^Pagó (.+)$/, (m) => `Paid by ${m[1]}`],
  [/^Recibió (.+)$/, (m) => `Received by ${m[1]}`],
  [/^(\d+) tareas?$/, (m) => plural(m[1], "task", "tasks")],
  [/^(\d+) personas?$/, (m) => plural(m[1], "person", "people")],
  [/^(\d+) deseos?$/, (m) => plural(m[1], "wish", "wishes")],
  [/^(\d+) recompensas?$/, (m) => plural(m[1], "reward", "rewards")],
  [/^(\d+) miembros?$/, (m) => plural(m[1], "member", "members")],
  [/^(\d+) ejecuciones$/, (m) => `${m[1]} runs`],
  [/^\+(\d+) más$/, (m) => `+${m[1]} more`],
  [/^Comprado \((\d+)\)$/, (m) => `Purchased (${m[1]})`],
  [/^Total: (.+)$/, (m) => `Total: ${m[1]}`],
  [/^Compartir "(.+)"$/, (m) => `Share "${m[1]}"`],
  [/^Compartir(\s*\(\d+\))?$/, (m) => `Share${m[1] || ""}`],
  [/^Creado por (.+)$/, (m) => `Created by ${m[1]}`],
];

export const getEffectiveLang = (user) => {
  if (user?.language === "en" || user?.language === "es") return user.language;
  const stored = localStorage.getItem("nuxxum_lang");
  if (stored === "en" || stored === "es") return stored;
  const nav = (navigator.language || "es").toLowerCase();
  return nav.startsWith("es") ? "es" : "en";
};

export const translateText = (s) => {
  if (!s) return s;
  const trimmed = s.trim();
  if (!trimmed || !/[A-Za-zÁÉÍÓÚÜáéíóúüñÑ¿¡]/.test(trimmed)) return s;
  const direct = DICT[trimmed];
  if (direct) return s.replace(trimmed, direct);
  for (const [re, fn] of RULES) {
    const m = trimmed.match(re);
    if (m) return s.replace(trimmed, fn(m));
  }
  return s;
};
